import type { IconProps } from '../types/IconProps.ts';
export const LayoutGrid: IconProps = {
    name: 'LayoutGrid',
    children: [
        `<rect width="7" height="7" x="3" y="3" rx=".5" />`,
        `<rect width="7" height="7" x="14" y="3" rx=".5" />`,
        `<rect width="7" height="7" x="3" y="14" rx=".5" />`,
        `<rect width="7" height="7" x="14" y="14" rx=".5" />`,
    ]
};